import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import FullscreenDialog from 'Components/UI/FullscreenDialog';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useUserContext from 'Context/UserContext';
import closeModal from 'Helpers/ModalHelper';
import Meeting from '../../UI/Meeting';

const styles = {
  root: {},
};

const ClientMeetingPreview = ({ classes, className }) => {
  const { householdResource } = useSimpleHousehold();
  const { agentResource } = useUserContext();

  return (
    <FullscreenDialog
      className={classNames(className, classes.root)}
      disableEnforceFocus
      title="Communications Preview"
      variant="white"
    >
      <Meeting
        householdResource={householdResource}
        leadPlannerResource={agentResource}
        sendMessageDisabled
        todosDisabled
        preview
        onLoadFailure={() => closeModal()}
      />
    </FullscreenDialog>
  );
};

ClientMeetingPreview.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

ClientMeetingPreview.defaultProps = {
  className: '',
};

export default withStyles(styles)(ClientMeetingPreview);
